import { from, from as observableFrom, Observable, Subject } from 'rxjs';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AcLayerComponent, AcNotification, ActionType } from 'angular-cesium';
import { GeoDevicesService } from 'src/app/services/mapa/geodevices.service';
import { map, switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'app-html-layer-devices',
  templateUrl: './html-layer-devices.component.html',
  styleUrls: ['./html-layer-devices.component.scss']
})
export class HtmlLayerDevicesComponent implements OnInit {


  // @Input() GeoPosDevices: AcNotification; 
  @Output() openTipoDatosModalEmitter: EventEmitter<null> = new EventEmitter();
  @Output() openDatosModalEmitter: EventEmitter<string> = new EventEmitter();

  @ViewChild(AcLayerComponent) layer: AcLayerComponent;
  htmls$: Observable<AcNotification>;
  entities$: Observable<AcNotification>;

  constructor(
    private geoDevicesService: GeoDevicesService
  ) {

    this.loadGeoPos();
  }

  ngOnInit() {
    
  }

  loadGeoPos(){
    this.entities$ = this.geoDevicesService.getAllGeoPos()
    .pipe(
      map( data => {
        // console.log (data);
        return data.map(geopos =>{
        const randomSign = () => Math.round(Math.random()) * 2 - 1;
        const lat = (geopos.latitud ? geopos.latitud : 70 * Math.random() * randomSign()) ;
        const long = (geopos.longitud ? geopos.longitud : 180 * Math.random() * randomSign());
        let entityMap:AcNotification;
        entityMap = {
          id: geopos.uuid,
          actionType: ActionType.ADD_UPDATE,
          entity:  {
                  id:geopos.uuid, 
                  name:  `${geopos.nombre}`,
                  position:Cesium.Cartesian3.fromDegrees(long, lat, 0.00),
                  show: true,
                  color: Cesium.Color.RED
                }
          }
          return entityMap;
        })
      }
      ),
      switchMap(data =>{
        return from (data as AcNotification[])
      }),
    );
    
  }  

  openTipoDatosModal(){
    this.openTipoDatosModalEmitter.emit();
  }

  showDatos(entity:AcNotification){
    this.openDatosModalEmitter.emit(entity.id);
  }
}
